var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportAndAdditionalServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15.474,
    viewBox: "0 0 14 15.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #101010;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-add-graph-report",
    className: "cls-1",
    d: "M9.658,4A1.66,1.66,0,0,0,8,5.658V17.079a1.66,1.66,0,0,0,1.658,1.658H14.5a4.666,4.666,0,0,1-.8-1.105H9.658a.552.552,0,0,1-.553-.553V5.658a.552.552,0,0,1,.553-.553h4.237V8.237a1.66,1.66,0,0,0,1.658,1.658h3.132v.792A4.874,4.874,0,0,1,19.789,11V9.342a.55.55,0,0,0-.162-.391L14.838,4.162A.55.55,0,0,0,14.447,4ZM15,5.887l2.9,2.9h-2.35A.552.552,0,0,1,15,8.237Zm2.947,5.482A4.053,4.053,0,1,0,22,15.421,4.053,4.053,0,0,0,17.947,11.368Zm-5.158.737a.737.737,0,0,0-.735.69L10.9,13.95a.736.736,0,1,0,.781.781l1.107-1.108.538.538a4.784,4.784,0,0,1,.456-1.105l-.26-.26A.737.737,0,0,0,12.789,12.105Zm5.158.368a.369.369,0,0,1,.368.368v2.211h2.211a.368.368,0,1,1,0,.737H18.316V18a.368.368,0,1,1-.737,0V15.789H15.368a.368.368,0,1,1,0-.737h2.211V12.842A.369.369,0,0,1,17.947,12.474Z",
    transform: "translate(-8 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAndAdditionalServices);
export default __webpack_public_path__ + "static/media/report_and_additional_services.24c9b49ff8ecb838a96770cce0ef339b.svg";
export { ForwardRef as ReactComponent };